export default {
  props: {
    allowFavorite: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    // Paraderos favoritos del usuario
    userFavoritesStops() {
      return (this.$user || {}).favorite_stop_ids || []
    },

    // Comprueba que el paradero es favorito
    // Debe tener stop entre los datos del compoente
    isFavorite() {
      return _.includes(this.userFavoritesStops, (this.stop || {}).id)
    }
  },

  methods: {
    setFavorite() {
      this.$emit('stop-favorite')
    }
  }
}
